/**
 * These routes exist so we can have defined named routes for Contentful-driven pages
 * that don't have their own dedicated route files.
 */

export default {
  path: '',
  component: () => import('src/pages/shared/ContentfulDynamicPage.vue'),
  children: [
    {
      path: 'retail-partners',
      name: 'RetailPartnersHome',
    },
    // customer terms of service
    {
      path: 'terms',
      name: 'CustomerTerms',
    },
    // customer privacy policy
    {
      path: 'privacy',
      name: 'CustomerPrivacy',
    },
    // help center home
    {
      path: 'help',
      name: 'HelpCenterHome',
    },
  ],
}
